import importerActions from 'modules/shared/importer/importerActions';
import selectors from 'modules/company/importer/companyImporterSelectors';
import CompanyService from 'modules/company/companyService';
import fields from 'modules/company/importer/companyImporterFields';
import { i18n } from 'i18n';

export default importerActions(
  'COMPANY_IMPORTER',
  selectors,
  CompanyService.import,
  fields,
  i18n('entities.company.importer.fileName'),
);
